/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IUniformCrossover,
  IUniformCrossoverInterface,
} from "../IUniformCrossover";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence1",
        type: "uint32[72]",
      },
      {
        internalType: "uint32[72]",
        name: "geneticSequence2",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "uniformCrossover",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IUniformCrossover__factory {
  static readonly abi = _abi;
  static createInterface(): IUniformCrossoverInterface {
    return new utils.Interface(_abi) as IUniformCrossoverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IUniformCrossover {
    return new Contract(address, _abi, signerOrProvider) as IUniformCrossover;
  }
}
